
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type singleVehicleGarageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function singleVehicleGarageRT(): TemplateResult<singleVehicleGarageRTRootProps> {
    return _createElement('div', { 'className': 'garage-container' }, [this.changeButton(function () {
            return _createElement('div', { 'className': 'cm_changeButton' }, _createElement('div', { 'className': 'garage-icon' }, _createElement('svg', {
                'width': '26',
                'height': '26',
                'viewBox': '0 0 40 40',
                'fill': 'currentColor',
                'xmlns': 'http://www.w3.org/2000/svg'
            }, _createElement('path', { 'd': 'M38.6,13.3h-4.3l-0.6-1.7c0-3.8-5.4-6.2-8.3-6.2H14.7c-2.9,0-8.3,2.8-8.5,6.7l-0.5,1.1H1.4c-0.4,0-0.7,0.3-0.7,0.7L1.4,16c0,0.4,0.3,0.7,0.7,0.7h2.6c-1.6,0.6-2.7,2.2-2.7,4v4.5c0,1,0.4,1.9,1,2.7V28v4.6c0,1,0.8,1.8,1.8,1.8h3.9c1,0,1.8-0.8,1.8-1.8v-3.1h19.3v3.1c0,1,0.8,1.8,1.8,1.8h3.9c1,0,1.8-0.8,1.8-1.8V28l0,0c0.6-0.7,1-1.7,1-2.7v-4.5c0-1.8-1.1-3.3-2.7-4h2.5c0.4,0,0.7-0.3,0.7-0.7l0.7-2.1C39.3,13.7,39,13.3,38.6,13.3z M9.6,15.7c1.3-3.6,3.4-5.8,5.7-5.8h10.1c2.2,0,4.6,2.7,5.2,6H9.5C9.5,15.7,9.6,15.7,9.6,15.7z M9.1,25.1H7.3c-1.3,0-2.4-1.1-2.4-2.4s1-2.4,2.3-2.4l0.5,0.1c1.6,0.1,3,1.7,3.1,2.7l0.1,0.7C10.8,25.1,10.3,25.1,9.1,25.1z M32.7,25.1h-1.8c-1.3,0-1.8,0-1.9-1.3l0.1-0.7c0.2-1,1.5-2.5,3.1-2.7l0.5-0.1c1.3,0,2.3,1.1,2.3,2.4C35.1,24,34,25.1,32.7,25.1z' }))), this.template === 'active' ? _createElement('div', {
                'className': 'active-container cmTemplate_active',
                'key': '942'
            }, window.Convermax.config?.selectYourVehicleTitle || _translate(`ymm_bar_title`)) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'locked-container cmTemplate_locked',
                'key': '1127'
            }, _createElement('span', { 'className': 'model' }, this.vehicleString), _createElement('span', { 'className': 'change' }, _translate(`single_vehicle_garage_change`))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], this.template === 'locked' ? _createElement('div', {
        'className': 'clear-garage cmTemplate_locked',
        'key': '2064'
    }, _createElement('div', {
        'className': 'cm_button',
        'onClick': this.discardVehicle
    }, _createElement('span', {}, _translate(`single_vehicle_garage_clear`)))) : null);
}
        export const componentNames = ["cm:changeButton"]